module.exports = __webpack_public_path__ + "img/indeximg2.14fd35d5.png";